import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: { main: '#1f2937' }, // Dark Gray
    secondary: { main: '#00bcd4' }, // Cyan
    background: { default: '#f3f4f6' }, // Light Gray
    
    // 5-bucket palette aligned to scoring.js buckets:
    // <=2, <=4, <=6, <=8, >8
    score: {
      b0: { main: "#d32f2f" }, // Severe pain (red)
      b1: { main: "#f57c00" }, // High friction (orange)
      b2: { main: "#fbc02d" }, // Workable (yellow)
      b3: { main: "#7cb342" }, // Smooth (yellow-green)
      b4: { main: "#2e7d32" }, // Excellent (green)
    },
  },
  typography: {
    fontFamily: 'Roboto, Arial, sans-serif',
    h6: { fontWeight: 600 },
  },
});

export default theme;
